/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Metric } from "web-vitals";

import Analytics from "./services/analytics";

// event values can only contain integers
function getEventValueFromMetric(metric: Metric) {
  if (metric.name === "CLS") {
    return Math.round(metric.value * 1000);
  }
  return Math.round(metric.value);
}

export function reportHandler(metric: Metric) {
  Analytics.push({
    dataLayer: {
      event: "Web Vitals",
      eventAction: metric.name,
      eventValue: getEventValueFromMetric(metric),
      eventLabel: metric.id,
      nonInteraction: true,
      data: metric,
    },
  });
}
